// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPrescription {
    static getAttributeTypeMap() {
        return MedicalBiPrescription.attributeTypeMap;
    }
}
MedicalBiPrescription.discriminator = undefined;
MedicalBiPrescription.additionalProperties = false;
MedicalBiPrescription.attributeTypeMap = [
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "drug",
        "baseName": "drug",
        "type": "string"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "string"
    },
    {
        "name": "daySupply",
        "baseName": "daySupply",
        "type": "string"
    },
    {
        "name": "sig",
        "baseName": "sig",
        "type": "string"
    },
    {
        "name": "refill",
        "baseName": "refill",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPrescription.js.map